var map = {
	"./assets/images/avatars/akash.png": 897,
	"./assets/images/avatars/almas.png": 867,
	"./assets/images/avatars/ferdous.png": 833,
	"./assets/images/avatars/riyadh.png": 869,
	"./assets/images/avatars/sadh.png": 42,
	"./assets/images/avatars/salahuddin.png": 314,
	"./assets/images/avatars/sumit.png": 131,
	"./assets/images/logo.svg": 835,
	"./assets/images/svg/delete.svg": 572,
	"./assets/styles/main.css": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;